export default [
  {
    url: '/',
    title: 'common.dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    route: 'dashboard',
    resource: 'view_dashboard',
  },
  {
    url: '/profile',
    title: 'payments.profile',
    slug: 'page-profile',
    icon: 'UserIcon',
    route: 'profile',
  },
  {
    url: '/apps',
    title: 'common.apps',
    slug: 'apps',
    icon: 'CopyIcon',
    route: 'apps',
    resource: 'view_apps',
  },
  {
    url: '/payments',
    title: 'common.payments',
    slug: 'payments',
    icon: 'DollarSignIcon',
    route: 'payments',
    resource: 'view_payments',
  },
  {
    title: 'common.statistics',
    icon: 'PieChartIcon',
    // No 'resource' key here anymore
    children: [
      {
        title: 'common.revenueStatistics',
        route: 'revenue-statistics',
        resource: 'view_revenue_stats',
      },
      {
        title: 'common.surveyStatistics',
        route: 'survey-statistics',
        resource: 'view_survey_stats',
      },
    ],
  },
  {
    title: 'common.logs',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'common.clickLog',
        route: 'click-log',
        resource: 'view_click_logs',
      },
      {
        title: 'common.postbackLog',
        route: 'postback-log',
        resource: 'view_postback_logs',
      },
      {
        title: 'common.transactionLog',
        route: 'transaction-log',
        resource: 'view_transaction_logs',
      },
    ],
  },
]
